import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { stories } from '../../data/homeContent';
import HomeIcon from './HomeIcon';
import storiesProgressImg from '../../assests/img/stories-progress.jpg';

function HomeStories() {
  const [open, setOpen] = useState(0);

  return (
    <section className="home-section home-stories" id="stories">
      <div className="container">
        <div className="home-stories-layout">
          <div className="home-stories-copy">
            <div className="home-section-head">
              <p className="home-kicker">STORIES OF PROGRESS</p>
              <h2>When a school stops managing chaos and starts leading</h2>
            </div>
            <div className="home-accordion">
              {stories.map((story, index) => {
                const isOpen = open === index;
                return (
                  <article key={story.title} className={isOpen ? 'is-open' : ''}>
                    <button type="button" onClick={() => setOpen(isOpen ? -1 : index)}>
                      <span className="home-story-icon" aria-hidden="true">
                        <HomeIcon name={story.icon} />
                      </span>
                      <span className="home-story-title">{story.title}</span>
                      <strong>{isOpen ? '−' : '+'}</strong>
                    </button>
                    {isOpen ? (
                      <div className="home-accordion-body">
                        <p>{story.text}</p>
                        <Link to={story.to}>Read the success story</Link>
                      </div>
                    ) : null}
                  </article>
                );
              })}
            </div>
          </div>

          <aside className="home-stories-media">
            <img src={storiesProgressImg} alt="Indian school leaders reviewing campus insights on a tablet" />
            <div className="home-stories-caption">
              <b>70%</b>
              <span>Less admin work after a school moves to one platform</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default HomeStories;
